import {
  Component,
  OnInit
} from "@angular/core";
import { AlertService } from "../../services/alert/alert.service";
import { UserService } from "src/app/services/user/user.service";
import AppConstants,{TypeOfUser as TOU, BusinessType as BT, UserRecertify as UR} from "src/app/shared/common-components/AppConstants";
import { ColDef, ColGroupDef, GridOptions } from "ag-grid-enterprise";
import { GridApi} from "ag-grid-community";
import moment from 'moment';
import { LoadingService } from "src/app/services/loading/loading.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ConfirmationModalComponent } from "../../shared/common-components/confirmation-modal/confirmation-modal.component";
@Component({
    selector: "app-user-recertification",
    templateUrl: "./user-recertification.component.html",
    styleUrls: ["./user-recertification.component.css"],
    standalone: false
})
export class UserRecertificationComponent implements OnInit {
  public errorMessage = "";
  order = "faic";
  reverse = false;

  isDisabled:boolean = true;
  paginationPageSize;
  domLayout;
  data: any[];
  organizationid: Number = -1;
  permission: string = "";
  typeOfUser: Array<string>;
  gridOptions: GridOptions;

  userColDef: (ColDef | ColGroupDef)[] = [];
  userId: Number;
  selectedValue: any;
  gridApi: GridApi;
  gridColumnApi: any;
  private tmssLoader: any;
  private alert: any;
  modalRef: BsModalRef;
  constructor(
    private alertService: AlertService,
    private userService: UserService,
    private loader: LoadingService,
    private modalService: BsModalService
  ) {
    this.tmssLoader = loader;
    this.alert = alertService;
  }

  ngOnInit() {
    this.defineGridOption();
    this.getUserDetails();
    this.initializedColDef();
  }

  getUserDetails() {
    this.userService.getCurrentUserDetails().subscribe((currentUser) => {
      if (AppConstants.isNotNullCondition(currentUser)) {
        this.organizationid = currentUser.organizationId
          ? currentUser.organizationId
          : -1;
        this.permission = currentUser.permissions;
        this.userId = currentUser.id;
        this.defineTypeOfUser();
        if (AppConstants.isNotNullCondition(this.typeOfUser)) {
          this.selectedValue = this.typeOfUser[0] ;
          this.onSelectUserType(null);
        }
        
      }
    });
  }

  onSelectUserType(event: any) {
   
    if (this.typeOfUser.includes(this.selectedValue)) {
      this.toggleColumnVisibility();
      this.getAgencyOrTSPList();
    }
  }

  initializedColDef() {
    this.userColDef = [
      <ColDef>{ 
        headerName: "Selection", 
        checkboxSelection: true, 
        headerCheckboxSelection: true,
        showDisabledCheckboxes: true,
        width: 100
      },
      {
        headerName: "First Name",
        field: "firstName",
        filter: "agTextColumnFilter",
        sortable: true,
        width: 150,
        cellClass: "textFormat",
      },
      {
        headerName: "Last Name",
        field: "lastName",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Bureau Name",
        field: "bureauName",
        colId: "bureauName",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Agency Name",
        field: "agencyName",
        colId: "agencyName",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "SCAC",
        field: "scac",
        colId: "scac",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "User Certify Status",
        field: "userStatus",
        filter: "agTextColumnFilter",
        sortable: true,
      },
      {
        headerName: "Certified Date",
        field: "certifyDate",
        cellRenderer: (data: any) => {
          return data.value ? (moment(data.value).format('MM/DD/YYYY')) : '';
        }
      },
      {
        headerName: "User Email",
        field: "email",
        filter: "agTextColumnFilter",
        cellRenderer: (data: any) => {
          return data.value ? (data.value).toLowerCase() : '';
        },
        sortable: true,
      },
      {
        headerName:"Last Login Date",
        field:"lastLoginDate",
        cellRenderer: (data: any) => {
          return data.value ? (moment(data.value).format('MM/DD/YYYY')) : '';
        }
      }
    ];
  }
  onSelectionChanged(event: any) {
    if(this.gridApi.getSelectedNodes().length >= 1) this.isDisabled = false;
    else this.isDisabled = true;
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    // this.gridApi.setDatasource(this.data);
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onDeleteUser() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, You Want to delete these user account(s)?';
    this.modalRef.content.title = 'User Certify';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe((result: any) => {
      if (result.obj === true) {
        const selectedData = this.gridApi?.getSelectedRows();
        if(AppConstants.isNotNullCondition(selectedData) && selectedData.length >= 1){
          this.isDisabled = false;
            this.userService.deleteUsersCertify(selectedData).subscribe((data: any) => {
                selectedData.forEach(a => {
                 a.userStatus = 'Deleted'
                });
                this.gridApi.applyTransaction({remove: selectedData });
                this.alert.success("Selected user account(s) were deleted !");
            },(error: any)=> {
              this.alert("Please try again later")
            });
        }
      }
    });
  }

  onRecertifyUser() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, You Want to continue?';
    this.modalRef.content.title = 'User Certify';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe((result: any) => {
      if (result.obj === true) {
        const selectedData = this.gridApi?.getSelectedRows();
        if(AppConstants.isNotNullCondition(selectedData) && selectedData.length >= 1){
          this.isDisabled = false;
            this.userService.updateUserCertify(selectedData).subscribe((data: any) => {
                selectedData.forEach(a => {
                  a.certifyDate = new Date();
                  a.certifyId = this.userId;
                  a.userStatus = "Certified";
                  
                });
                this.gridApi.applyTransaction({update: selectedData });
                this.alert.success("Selected user account(s) were certified !");
                this.gridApi?.deselectAll();
            },(error: any)=> {
              this.alert("Please try again later")
            });
        }
      }
    });
  }

  getAgencyOrTSPList(){
    this.tmssLoader.show();
    this.userService.getAgencyOrTSPList(this.permission, this.selectedValue).subscribe({
      next: (response: any) => {
        this.data = response;
        this.tmssLoader.hide();
      },
      error: (error: any) => {
        this.tmssLoader.hide();
        this.alert.error("Unable to fetch latest information");
        // treat error
      },
      complete: () => {
        this.tmssLoader.hide();
        // define on request complete logic
        // 'complete' is not the same as 'finalize'!!
        // this logic will not be executed if error is fired
      }
    })
  }

  defineGridOption(){
    this.gridOptions = {
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      rowHeight: 40,
      pagination: true,
      paginationPageSize: 100,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  defineTypeOfUser(){
    if(this.permission === BT.HHG_FRT)
      this.typeOfUser = [TOU.INTERNAL];
    else
      this.typeOfUser = [TOU.AGENCY, TOU.TSP];
  }

  toggleColumnVisibility(){
    if(!this.gridColumnApi) return;
    if(this.selectedValue === TOU.AGENCY){
      this.gridColumnApi.setColumnsVisible(['bureauName', 'agencyName'], true);
      this.gridColumnApi.setColumnVisible('scac', false);
    }
    if(this.selectedValue === TOU.TSP){
      this.gridColumnApi.setColumnsVisible(['bureauName', 'agencyName'], false);
      this.gridColumnApi.setColumnVisible('scac', true);
    }
  }
}